
import React from "react";
import { Button } from "@/components/ui/button";
import { Binoculars } from "lucide-react";
import { PackageCard } from "@/components/hunting/PackageCard";

// Package data (moved from main file)
const packageTypes = [
  {
    id: "non-hunter",
    title: "Non-Hunter",
    price: 150,
    description: "Per day rate for non-hunters accompanying the hunting party",
    days: 1,
    badgeText: "Non-Hunter",
    badgeColor: "bg-blue-500"
  }, 
  {
    id: "transportation",
    title: "Transportation",
    price: 400,
    description: "Transportation from Boise/Elko",
    days: 1,
    badgeText: "Transportation",
    badgeColor: "bg-purple-500"
  }, 
  {
    id: "1hunter-1guide",
    title: "1 Hunter/1 Guide",
    price: 2000,
    description: "3-day guided hunt, one antelope",
    days: 3,
    hunters: 1,
    guides: 1
  }, 
  {
    id: "youth",
    title: "Youth Hunter (12-17)",
    price: 2000,
    description: "Must be accompanied by an adult hunter",
    days: 3,
    hunters: 1,
    badgeText: "Youth",
    badgeColor: "bg-green-500"
  }, 
  {
    id: "2hunters-1guide",
    title: "2 Hunters/1 Guide",
    price: 4000,
    description: "3-day guided hunt, one antelope per hunter",
    days: 3,
    hunters: 2,
    guides: 1
  }
];

interface PackageSectionProps {
  huntTypeId: string;
  selectedPackage: string | null;
  setSelectedPackage: (id: string | null) => void;
  handleReserveClick: () => void;
}

export const PackageSection: React.FC<PackageSectionProps> = ({
  huntTypeId,
  selectedPackage,
  setSelectedPackage,
  handleReserveClick
}) => {
  return (
    <>
      <h2 className="text-3xl font-bold mb-6 text-tribal-secondary">Available Packages</h2>
      <div className="grid md:grid-cols-3 gap-6 mb-12">
        {packageTypes.map(packageType => (
          <PackageCard 
            key={packageType.id} 
            {...packageType} 
            isSelected={selectedPackage === packageType.id} 
            onClick={() => setSelectedPackage(packageType.id)} 
          />
        ))}
      </div>
      
      {selectedPackage && (
        <div className="flex justify-center mt-8">
          <Button 
            className="text-lg py-6 px-8 bg-tribal-primary hover:bg-tribal-primary/90" 
            onClick={handleReserveClick}
          >
            <Binoculars className="mr-2 h-5 w-5" />
            Reserve Your Hunt
          </Button>
        </div>
      )}
    </>
  );
};
